// extracted by mini-css-extract-plugin
export default {"card_title":"styles_card_title__xkMox","card_subtitle":"styles_card_subtitle__IGleF"};